// import config from "~/config.server";

export default function (
  url?: string,
  env?: "staging" | "production" | undefined
) {
  const hasWindow = typeof window !== "undefined";

  if (!url) return;
  // this next to conditions is important for the widget becase it does not have access to ENV
  if (env === "staging")
    return "https://lernplattform.limburg.voidmod.com/api/v2" + url;
  if (env === "production") return "https://api.ru-digital.de" + url;
  if (hasWindow) {
    //@ts-ignore
    const baseUrl = window?.ENV?.BASEURL;
    if (baseUrl) return baseUrl + url;
  }
  // SSR: use the server env variable; fall back to production URL
  const serverBase =
    typeof process !== "undefined" ? process.env.BASEURL : undefined;
  return (serverBase || "https://api.ru-digital.de") + url;
}
